<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card >
        <vs-popup classContent="popup-example" title="Nouveau style" :active.sync="popupType">
          <div class="vx-row mb-6">

            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" type="text" label="Style Abreg" v-validate="'required'" name="Type_Abreg" v-model="Type_Abreg" />
              <span class="text-danger text-sm"  v-show="errors.has('Type_Abreg')">{{ errors.first('Type_Abreg') }}</span>
            </div>

            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" type="text" label="Libelle Style" v-validate="'required'" name="Libelle_Type" v-model="Libelle_Type" />
              <span class="text-danger text-sm"  v-show="errors.has('Libelle_Type')">{{ errors.first('Libelle_Type') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" @click="addType" :disabled="!validateForm">Enregistrer</vs-button>
              <vs-button color="warning" type="border" class="mb-2" @click="Type_Abreg = ''; ">Annuler</vs-button>
            </div>
          </div>
        </vs-popup>

        <vs-popup classContent="popup-example" title="Modifier une style" :active.sync="popupTypeUpdate">

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
              <vs-input class="w-full mt-4" type="text" label="Style Abreg" v-validate="'required'" name="Type_Abreg" v-model="Type_Abreg" />
              <span class="text-danger text-sm"  v-show="errors.has('Type_Abreg')">{{ errors.first('Type_Abreg') }}</span>
            </div>

            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" type="text" label="Libelle Style" v-validate="'required'" name="Libelle_Type" v-model="Libelle_Type" />
              <span class="text-danger text-sm"  v-show="errors.has('Libelle_Type')">{{ errors.first('Libelle_Type') }}</span>
            </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-2/3 w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="updateType" :disabled="!validateForm">Modifier</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="Type_Abreg = '';  popupTypeUpdate = false;">Annuler</vs-button>
          </div>
        </div>
        </vs-popup>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-table noDataText="" v-model="selected" pagination max-items="10" search :data="typeData">
              <template slot="header">
                <!-- ACTION - DROPDOWN -->
                <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">

                  <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
                    <span class="mr-2 leading-none">Actions</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>

                  <vs-dropdown-menu>

                    <vs-dropdown-item>
                      <span class="flex items-center">
                        <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                        <span>Supprimer</span>
                      </span>
                    </vs-dropdown-item>

                    <vs-dropdown-item>
                      <span class="flex items-center">
                        <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                        <span>Print</span>
                      </span>
                    </vs-dropdown-item>

                    <vs-dropdown-item>
                      <span class="flex items-center">
                        <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                        <span>CSV</span>
                      </span>
                    </vs-dropdown-item>

                  </vs-dropdown-menu>
                </vs-dropdown> -->
                <vs-button class="mb-4 md:mb-0" @click="popupType=true">Nouveau type</vs-button>
              </template>
              <template slot="thead">
                <vs-th>
                  ##
                </vs-th>
                <vs-th sort-key="Type_Abreg">
                  Type Abreg
                </vs-th>
                <vs-th sort-key="Libelle_Type">
                  Libelle Type
                </vs-th>
                <vs-th>
                  Action
                </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td :data="data[indextr]">
                    {{indextr + 1}}
                  </vs-td>

                  <vs-td :data="data[indextr].Type_Abreg">
                    {{data[indextr].Type_Abreg}}
                  </vs-td>

                  <vs-td :data="data[indextr].Libelle_Type">
                    {{data[indextr].Libelle_Type}}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="updateTypeShowForm(data[indextr])" />
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr])" />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      popupType: false,
      popupTypeUpdate: false,
      Type_Abreg: '',
      Libelle_Type: '',
      selected:[],
      types:[],
      typeId: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.Type_Abreg !== '' && this.Libelle_Type !== ''
    },
    typeData () {
      return this.$store.state.type.types
    }
  },

  methods: {
    addType () {
      const payload = {
        Type_Abreg: this.Type_Abreg,
        Libelle_Type: this.Libelle_Type
      }

      this.$vs.loading({
        type:'sound'
      })
      this.$store.dispatch('type/addType', payload)
        .then(() => {
          this.$vs.notify({
            title: 'success',
            text: 'success',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.resete_data()
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.$vs.loading.close()
          this.popupType = false
        })
    },
    confirmDeleteRecord (data) {
      this.typeId = data._id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmé la Suppression',
        text: `Vous allez supprimer le style "${data.Type_Abreg}"`,
        accept: this.deleteRecord,
        acceptText: 'Supprimer'
      })
    },
    deleteRecord () {
      this.$vs.loading({
        type:'sound'
      })
      this.$store.dispatch('type/removeType', this.typeId)
        .then(() => {
          this.typeId = ''
          this.showDeleteSuccess()
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'danger',
        title: 'success',
        text: 'Le style selectionnée a bien été supprimée'
      })
    },
    getTypes () {
      this.$vs.loading({
        type:'sound'
      })
      this.$store.dispatch('type/getTypes')
        .then(() => {
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    updateTypeShowForm (data) {
      this.Type_Abreg = data.Type_Abreg
      this.Libelle_Type = data.Libelle_Type
      this.typeId = data._id
      this.popupTypeUpdate = true
    },
    updateType () {

      const payload = {
        Type_Abreg: this.Type_Abreg,
        Libelle_Type: this.Libelle_Type,
        id: this.typeId
      }

      this.$vs.loading({
        type:'sound'
      })

      this.$store.dispatch('type/updateType', payload)
        .then(() => {
          this.$vs.notify({
            title: 'success',
            text: 'success',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.resete_data()
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.$vs.loading.close()
          this.popupTypeUpdate = false
        })
    },
    resete_data () {
      this.Type_Abreg = this.Libelle_Type = ''
    }
  },
  created () {
    this.getTypes()
  }
}
</script>

